import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
class SecondaryNav extends Component {

    generateTitle(title){
        if(title){
            return (<h2>{title}</h2>);
        } else {
            return null;
        }
    }
    
    generateNav(section){
        const servicesNav = (
            <ul role="navigation" className="secondary-nav-list list-inline" aria-label="secondary navigation">
                <li><NavLink activeClassName="active" to="/services/tradeshow_management">Tradeshow Management</NavLink></li>
                <li><NavLink activeClassName="active" to="/services/exhibit_management">Exhibit Management</NavLink></li>
            </ul>
        );

        const displaysNav = (
            <ul role="navigation" className="secondary-nav-list list-inline" aria-label="secondary navigation">
                <li><NavLink activeClassName="active" to="/displays/displays">Displays</NavLink></li>
                <li><NavLink activeClassName="active" to="/displays/custom_fabrication">Custom Fabrication</NavLink></li>
            </ul>
        );
        
        switch (section) {
            case "services":
                return servicesNav;
            case "displays":
                return displaysNav;
            default:
                return (<div className="noSubnav"></div>);
        }
    }

  render() {
    return (
      <div className={"secondary-nav-outer"}>
        <div className="container secondary-nav">
          <div className="row">
            <div className="hidden-sm col-md-4">
                {this.generateTitle(this.props.title)}
            </div>
            <div className="col-sm-12 col-md-8 hidden-xs desktop-secondary-nav">
                {this.generateNav(this.props.section)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SecondaryNav;



// WEBPACK FOOTER //
// ./src/components/SecondaryNav/SecondaryNav.js